import { render, staticRenderFns } from "./AmazingExperience.vue?vue&type=template&id=2e1a8378&"
import script from "./AmazingExperience.vue?vue&type=script&lang=js&"
export * from "./AmazingExperience.vue?vue&type=script&lang=js&"
import style0 from "./AmazingExperience.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports